import { getCheckoutSettings as publicGetCheckoutSettings, updateCheckoutSettings as publicUpdateCheckoutSettings, } from './ecom-v1-checkout-settings-checkout-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { onCheckoutSettingsUpdated as publicOnCheckoutSettingsUpdated } from './ecom-v1-checkout-settings-checkout-settings.public.js';
export const getCheckoutSettings = /*#__PURE__*/ createRESTModule(publicGetCheckoutSettings);
export const updateCheckoutSettings = /*#__PURE__*/ createRESTModule(publicUpdateCheckoutSettings);
/**
 * Triggered when checkout settings are updated.
 */
export const onCheckoutSettingsUpdated = createEventModule(publicOnCheckoutSettingsUpdated);
export { LogoSize, Alignment, WebhookIdentityType, } from './ecom-v1-checkout-settings-checkout-settings.universal.js';
//# sourceMappingURL=ecom-v1-checkout-settings-checkout-settings.context.js.map